import { SelectV2, SelectV2Option } from '@cimplico/components';
import { useEffect, useState } from 'react';
import { AccountClass } from '../../types/account';
import { formatMixedCase } from '../../utilities/formatting';

type AccountClassSelectProps = {
    values: AccountClass[];
    errorMessage?: string;
    disabledHint?: string;
    isDisabled?: boolean;
    onChange: (accountClasses: AccountClass[]) => void;
};

function AccountClassSelect({ values, errorMessage, disabledHint, isDisabled, onChange }: AccountClassSelectProps): JSX.Element {
    const [selected, setSelected] = useState<SelectV2Option[]>([]);
    const [search, setSearch] = useState('');

    function handleEntityTypeChange(options: SelectV2Option[]): void {
        onChange(options.map((o) => o.value as AccountClass));
    }

    const options: { [key: string]: AccountClass } = {
        Asset: AccountClass.ASSET,
        Liability: AccountClass.LIABILITY,
        Revenue: AccountClass.REVENUE,
        Expense: AccountClass.EXPENSE,
        Equity: AccountClass.EQUITY,
    };

    useEffect(() => {
        const defaultSelected: SelectV2Option[] = values.map((value) => {
            return { label: formatMixedCase(value), value };
        });
        setSelected(defaultSelected);
    }, [values]);

    return (
        <div>
            <SelectV2
                isMulti
                keepSelectedOptions
                allowOverflow
                size="small"
                placeholder="Select tax rate type..."
                errorMessage={errorMessage}
                value={selected}
                disabled={isDisabled}
                disabledHint={disabledHint}
                onSearch={setSearch}
                onChange={handleEntityTypeChange}
                options={Object.keys(options)
                    .filter((opt) => opt.toLowerCase().includes(search.toLowerCase()))
                    .map((option) => {
                        return { label: option, value: options[option] };
                    })}
            />
        </div>
    );
}
export default AccountClassSelect;
